import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { SpocManagementSortOrder } from "./spocManagementSortOrder";


export namespace GetProjectSpocsSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      USER_NAME = "USER_NAME",
      ADDED_ON = "ADDED_ON",
      EXPIRES_ON = "EXPIRES_ON",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetProjectSpocsSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "USER_NAME":
          return ColumnName.USER_NAME;
        case "ADDED_ON":
          return ColumnName.ADDED_ON;
        case "EXPIRES_ON":
          return ColumnName.EXPIRES_ON;
        default:
          throw new InvalidGetProjectSpocsSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetProjectSpocsSortOrderDTO {
  sortIndex: number;
  columnName: GetProjectSpocsSortOrderEnums.ColumnName.ColumnNameDTO;
  order: SpocManagementSortOrder.SpocManagementSortOrderDTO;
}

export class GetProjectSpocsSortOrder {
  readonly isGetProjectSpocsSortOrderGetProjectSpocsSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetProjectSpocsSortOrderEnums.ColumnName.ColumnName;
  readonly order: SpocManagementSortOrder.SpocManagementSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetProjectSpocsSortOrderEnums.ColumnName.ColumnName, 
  order: SpocManagementSortOrder.SpocManagementSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetProjectSpocsSortOrderDTO): GetProjectSpocsSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetProjectSpocsSortOrderSortIndexError);
    const columnName = GetProjectSpocsSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetProjectSpocsSortOrderColumnNameError));
    const order = SpocManagementSortOrder.fromDTO(getObject(dto, "order", InvalidGetProjectSpocsSortOrderOrderError));
    return new GetProjectSpocsSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetProjectSpocsSortOrderDTO {
    const dto: GetProjectSpocsSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetProjectSpocsSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: SpocManagementSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetProjectSpocsSortOrder.prototype.toString = function toString(): string {
  return `GetProjectSpocsSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetProjectSpocsSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsSortOrderError";
  }
}
export class InvalidGetProjectSpocsSortOrderSortIndexError extends InvalidGetProjectSpocsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsSortOrderSortIndexError";
  }
}

export class InvalidGetProjectSpocsSortOrderColumnNameError extends InvalidGetProjectSpocsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsSortOrderColumnNameError";
  }
}

export class InvalidGetProjectSpocsSortOrderColumnNameUserNameError extends InvalidGetProjectSpocsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsSortOrderColumnNameUserNameError";
  }
}

export class InvalidGetProjectSpocsSortOrderColumnNameAddedOnError extends InvalidGetProjectSpocsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsSortOrderColumnNameAddedOnError";
  }
}

export class InvalidGetProjectSpocsSortOrderColumnNameExpiresOnError extends InvalidGetProjectSpocsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsSortOrderColumnNameExpiresOnError";
  }
}

export class InvalidGetProjectSpocsSortOrderOrderError extends InvalidGetProjectSpocsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsSortOrderOrderError";
  }
}
